export default "<img\n  *ngIf=\"promotions?.length\"\n  [src]=\"promotions[0].image_url\"\n  alt=\"\"\n  (click)=\"activate(promotions[0].code)\"\n>\n"